import React, { FC } from 'react';
import Reviews from '@components/Reviews';
import { Box } from '@wix/design-system';
import dynamic from 'next/dynamic';
import { ACTIONS } from '@components/Contexts/TemplateContext';
import ReviewUnavailableNotification from 'components/Template/TemplateReviews/ReviewUnavailableNotification';
import { useTemplateReviewsLogic } from './hooks/useTemplateReviewsLogic';
import { useTemplateReviewsConfig } from './hooks/useTemplateReviewsConfig';

const DynamicTemplateReviewModal = dynamic(
  () => import('@components/Reviews/ReviewModal/TemplateReviewModal'),
);

type TemplateReviewsProps = {
  isMobileView: boolean;
  showReviewsCount: boolean;
};

const TemplateReviews: FC<TemplateReviewsProps> = ({
  isMobileView,
  showReviewsCount,
}) => {
  // Extract all business logic
  const logic = useTemplateReviewsLogic(isMobileView);

  // Extract all configuration
  const { contentProps, infiniteScrollProps } = useTemplateReviewsConfig({
    ...logic,
    isMobileView,
    showReviewsCount,
  });

  const {
    template,
    onSubmitSuccess,
    handleBiGenericClick,
    showErrorNotification,
    setShowErrorNotification,
    dispatch,
  } = logic;

  return (
    <Box dataHook="template-reviews" width="100%">
      <DynamicTemplateReviewModal
        id={template.id}
        templateName={template.title}
        businessName={template.partnerProfileDetails.businessName}
        templateMediaSources={template.media.additionalImages}
        onSubmitSuccess={onSubmitSuccess}
        isMobileView={isMobileView}
        onClose={() => {
          dispatch({
            type: ACTIONS.REVIEW_MODAL_AUTO_FOCUS,
            reviewModalAutoFocus: false,
          });
        }}
        handleBiGenericClick={handleBiGenericClick}
      />
      <Reviews
        paginationMode="infiniteScroll"
        infiniteScrollProps={infiniteScrollProps}
        content={contentProps}
      />
      <ReviewUnavailableNotification
        show={showErrorNotification}
        onClose={() => setShowErrorNotification(false)}
        isMobileView={isMobileView}
      />
    </Box>
  );
};

export default TemplateReviews;
